// extracted by mini-css-extract-plugin
export default {"error_page":"error_page","errorPage":"error_page","row":"row","error-container":"error-container","errorContainer":"error-container","container":"container"};